export default "__VITE_ASSET__3LpRmM5d__"